// extracted by mini-css-extract-plugin
module.exports = {"popover":"_97fbec4","popoverContainer":"_9a4ea02","category":"_c22e917","iconText":"_c157987"};